// import CountUp from 'react-countup';
import { ThemeType } from 'types';

interface HeadlineProps {
  icon: React.ReactNode;
  children?: React.ReactNode;
  ariaKey: string;
  theme: ThemeType;
  description: string;
  value: number;
  prefix?: string;
  suffix?: string;
}

export default function Headline(props: HeadlineProps) {
  const textTheme = props.theme === 'tertiary' ? 'text-black' : 'text-white';

  return (
    <div className={`py-8 p-4 space-y-2 bg-${props.theme} md:p-8`}>
      {props.icon}
      <h2
        className={`font-bold text-2xl ${textTheme}`}
        aria-describedby={`headline-${props.ariaKey}-desc`}
      >
        {/* <CountUp
          duration={3}
          end={props.value}
          suffix={props.suffix ? ` ${props.suffix}` : ''}
          prefix={props.prefix}
        /> */}
        <p>
          {props.prefix}
          {props.value.toLocaleString()}{' '}
          {props.suffix ? ` ${props.suffix}` : ''}
        </p>
      </h2>
      <p
        className={`font-bold ${textTheme}`}
        id={`headline-${props.ariaKey}-desc`}
      >
        {props.description}
      </p>
      {props.children}
    </div>
  );
}
